import React from 'react';
import { styled } from 'themes';
import Button from 'components/buttons';
import { useTranslation } from 'react-i18next';
import { ROUTES } from 'navigation/route-map';

type Props = {
  title: string;
};

const GetStarted = (props: Props) => {
  const { title } = props;
  const [t] = useTranslation();
  return (
    <Section>
      <Title>{title}</Title>
      <Subtitle>{t('section--get-started.subheading')}</Subtitle>
      <Button
        to={ROUTES.DOWNLOAD}
        label={t('section--get-started.cta-label')}
      />
    </Section>
  );
};

const Section = styled.section`
  grid-column: full-start / full-end;
  background-color: ${({ theme }) => theme.colors.yellowSnow};
  padding: 10rem 3rem;
  margin-bottom: -10rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Title = styled.h2`
  margin-bottom: 1rem;
  font-size: 3.5rem;
  text-align: center;
`;

const Subtitle = styled.p`
  font-size: 2rem;
  margin-bottom: 3rem;
  text-align: center;
`;

export default GetStarted;

// import React from 'react';
// import { styled } from 'themes';
// import { Box, Text, LinkTexting } from 'components';
// import { device } from 'themes/media-queries';
// import Badges from 'components/badges';

// const GetStarted = () => {
//   return (
//     <Section>
//       <Content>
//         <Title>Kom igång</Title>
//         <Subtitle>
//           Du hittar Yepstr i Google Play och Appstore eller ange ditt
//           telefonnummer så SMSar vi en länk till appen!
//         </Subtitle>
//         <LinkTexting />
//         <DownloadBadges />
//       </Content>
//     </Section>
//   );
// };

// const Section = styled.section`
//   grid-column: full-start / full-end;
//   background-color: ${({ theme }) => theme.colors.yellowSnow};
//   padding: 5rem 0;
//   margin-bottom: -10rem;

//   display: grid;
//   grid-template-columns:
//     [full-start] minmax(6rem, 1fr) [semi-full-start] minmax(6rem, 1fr) [center-start]
//     repeat(8, [col-start] minmax(min-content, 18rem) [col-end])
//     [center-end] minmax(6rem, 1fr) [semi-full-end] minmax(6rem, 1fr) [full-end];

//   @media ${device.laptop} {
//     grid-template-columns:
//       [full-start] minmax(3rem, 1fr) [semi-full-start] minmax(3rem, 1fr) [center-start]
//       repeat(8, [col-start] minmax(min-content, 18rem) [col-end])
//       [center-end] minmax(3rem, 1fr) [semi-full-end] minmax(3rem, 1fr) [full-end];
//   }

//   @media ${device.mobileL} {
//     padding-top: 2rem;
//     padding-bottom: 2rem;

//     grid-template-columns:
//       [full-start] minmax(1rem, 1fr) [semi-full-start] minmax(1rem, 1fr) [center-start]
//       repeat(8, [col-start] minmax(min-content, 18rem) [col-end])
//       [center-end] minmax(1rem, 1fr) [semi-full-end] minmax(1rem, 1fr) [full-end];
//   }
// `;

// const Content = styled.div`
//   grid-column: center-start / center-end;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   text-align: center;
// `;

// const Title = styled.h2`
//   margin-bottom: 3px;
// `;

// const Subtitle = styled.p`
//   font-size: 2.2rem;
//   margin-bottom: 2rem;
// `;

// const DownloadBadges = styled(Badges)`
//   margin-top: 3rem;
// `;

// export default GetStarted;
